export const parentLetterIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Parent Letters is where you can access and download the WordFlight Parent Letter in English or Spanish '
  }
];
